import { ModalsProvider as MTModalsProvider } from '@mantine/modals';
import { PropsWithChildren } from 'react';

import { BalanceDetailsModal } from 'src/Components/Modals/BalanceDetailsModal';
import { BookDemoModal } from 'src/Components/Modals/BookDemoModal';
import { DuplicateContactModalContent } from 'src/Components/Modals/Content/DuplicateContactModalContent';
import { InnerProps } from 'src/Components/Modals/Content/DuplicateContactModalContent/DuplicateContactModalContent.types';
import { InfoModal } from 'src/Components/Modals/InfoModal';
import { InviteTypeModal } from 'src/Components/Modals/InviteTypeModal';
import { OperationTypeModal } from 'src/Components/Modals/OperationTypeModal';
import { VideoTutorialModal } from 'src/Components/Modals/VideoTutorialModal';
import { WelcomeVideoModal } from 'src/Components/Modals/WelcomeVideoModal';

import ProfileCompletionModal from '../../Components/Modals/ProfileCompletionModal/ProfileCompletionModal.component';

const modals = {
  duplicateContactModal: ({
    context,
    id,
    innerProps,
  }: {
    context: { closeModal: (id: string) => void };
    id: string;
    innerProps: InnerProps;
  }) => <DuplicateContactModalContent context={context} id={id} innerProps={innerProps} />,
  info: InfoModal,
  inviteType: InviteTypeModal,
  profileCompletion: ProfileCompletionModal,
  welcomeVideo: WelcomeVideoModal,
  balanceDetails: BalanceDetailsModal,
  videoTutorial: VideoTutorialModal,
  operationType: OperationTypeModal,
  bookDemo: BookDemoModal,
};

const ModalsProvider = ({ children }: PropsWithChildren) => {
  return <MTModalsProvider modals={modals}>{children}</MTModalsProvider>;
};

export default ModalsProvider;
